<app-loading-indicator></app-loading-indicator>
<router-outlet></router-outlet>
<app-toaster aria-live="polite" aria-atomic="true"></app-toaster>
